import(/* webpackMode: "eager" */ "/vercel/path0/components/Advertising.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/header/BaseMenu.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/layout/header/Live.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/partials/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["AddressInfo","LuIcon"] */ "/vercel/path0/components/partials/Helpers.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/components/partials/ShadowBox.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/SinglePage.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/box/box.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/flex/flex.js");
;
import(/* webpackMode: "eager", webpackExports: ["Image"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/image/image.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/link/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["Stack"] */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/stack/stack.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/typography/heading.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@chakra-ui/react/dist/esm/components/typography/text.js");
